import { Link } from "react-router-dom";
import { SearchX } from "lucide-react";
import { Button } from "../ui/button";

interface FacilityNotFoundPageProps {
  /** Overview path of a facility to offer as the way back — omitted when the user has none. */
  fallbackFacilityPath?: string;
}

// Shown by RequireFacility in place of a facility-scoped page when the
// facility in the URL doesn't exist or the user can't access it (a typed,
// edited or shared link) — the backend 404s every facility request for it,
// which pages otherwise surface only as "No data available". Distinct from
// FacilityDeactivatedPage, which covers a facility that exists but is no
// longer active.
export default function FacilityNotFoundPage({
  fallbackFacilityPath,
}: FacilityNotFoundPageProps) {
  return (
    <div className="flex h-screen flex-col items-center justify-center text-center px-4">
      <div className="w-12 h-12 rounded-lg flex items-center justify-center mb-3 bg-[var(--custom-slate-25)] border border-[var(--custom-slate-50)]">
        <SearchX size={22} className="text-[var(--custom-slate-500)]" />
      </div>
      <h2 className="text-lg font-semibold text-gray-900 mb-1">
        Facility not found
      </h2>
      <p className="text-sm text-gray-500 max-w-sm">
        This facility doesn't exist or you don't have access to it.
      </p>
      {fallbackFacilityPath && (
        <Button
          asChild
          className="mt-4 h-9 px-4 rounded-md bg-[#1876F2] text-white text-sm font-medium hover:bg-[#1876F2]/90 cursor-pointer"
        >
          <Link to={fallbackFacilityPath}>Go to active facility</Link>
        </Button>
      )}
    </div>
  );
}
